import { render, staticRenderFns } from "./BiayaAdmin.vue?vue&type=template&id=7d240e32&scoped=true&"
import script from "./BiayaAdmin.vue?vue&type=script&lang=js&"
export * from "./BiayaAdmin.vue?vue&type=script&lang=js&"
import style0 from "./BiayaAdmin.vue?vue&type=style&index=0&id=7d240e32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d240e32",
  null
  
)

export default component.exports